export default {
  serialize(date) {
    if (date !== null && date !== undefined) {
      return {
        date_string: date.toISOString()
      };
    } else {
      return undefined;
    }
  },
  deserialize(proto) {
    if (proto !== null && proto !== undefined) {
      return new Date(proto.date_string);
    } else {
      return undefined;
    }
  }
};